@if (headerFixed) {

<ui-toolbar-top [title]="headerTitle" [titleClass]="headerTitleClass" [state]="headerState"
  [backVisible]="headerBackVisible"></ui-toolbar-top>

}

@if (page$ | async; as page)
{

@if (page.html) {
<div #content class="content" cdkScrollable>

  @if (headerInline) {

  <ui-toolbar-top [title]="headerTitle" [titleClass]="headerTitleClass" [state]="headerState"
    [backVisible]="headerBackVisible"></ui-toolbar-top>

  }

  <div class="content-html" [innerHTML]="contentHTML"></div>

</div>
}
@else {

<div #content class="content" cdkScrollable>

  @if (headerInline) {

  <ui-toolbar-top [title]="headerTitle" [titleClass]="headerTitleClass" [state]="headerState"
    [backVisible]="headerBackVisible"></ui-toolbar-top>

  }

  @for (section of page.sections; track section) {

  <ui-page-section #sections [pageComponent]="this" [section]="section"></ui-page-section>

  }

</div>

}

}

<ui-btn-fab icon="vertical_align_top" [class.visible]="scrolled" (onClick)="scrollToTop()"></ui-btn-fab>